import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Tippy from '@tippyjs/react';
import {Info} from '@phosphor-icons/react';
import 'tippy.js/dist/tippy.css';

const GlobalControl = ({label, tooltip, children}) => {
    const [fillIcon, setFillIcon] = useState(false);

    return (
        <div className="global-controls-bar-item">
            <div className="global-controls-bar-item-label">
                {label && <p>{label}</p>}
                {tooltip && (
                    <Tippy
                        content={tooltip}
                        placement="top"
                        theme="label-tooltip"
                    >
                        <Info
                            size={16}
                            weight={fillIcon ? 'fill' : 'regular'}
                            onMouseEnter={() => setFillIcon(true)}
                            onMouseLeave={() => setFillIcon(false)}
                        />
                    </Tippy>
                )}
            </div>
            <div className="global-controls-bar-item-control">{children}</div>
        </div>
    );
};

GlobalControl.propTypes = {
    label: PropTypes.string,
    tooltip: PropTypes.string,
    children: PropTypes.node.isRequired,
};

export default GlobalControl;
